export const config = {
  id: 'oregonTier1Lmi',
  path: '/oregon-tier-1-lmi',
  // Deprecated: keep config for redirects/IDs, but do not register a route.
  // appRedirectPath consolidates this path to /oregon-tier-1 (preserving query params).
  show: () => false,
};
